import { useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  let changeBoardId = useDataChange({
    context: 'selected',
    path: 'board_id',
    viewPath: props.viewPath,
  })

  let changeStageId = useDataChange({
    context: 'selected',
    path: 'stage_id',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    changeBoardId(value)
    changeStageId(null)
  }
}
